<script>
export default {
	props: {
		label: {
			type: String,
			default: '',
		},
		textareaIdentifier: {
			type: String,
			default: '',
		},
		val: {
			type: [String, Number],
			default: '',
		},
	},
};
</script>

<template>
	<div>
		<label
			class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
			:for="textareaIdentifier"
			>{{ label }}</label
		>
		<textarea
			class="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 text-gray-900 dark:text-gray-100 bg-white dark:bg-black rounded-md shadow-sm focus:ring-1 focus:ring-gray-500 focus:border-gray-500 transition-colors sm:text-sm"
			:id="textareaIdentifier"
			:name="textareaIdentifier"
			:aria-label="textareaIdentifier"
			:placeholder="label"
			v-bind="$attrs"
			@input="$emit('update:val', $event.target.value)"
			cols="14"
			rows="6"
		></textarea>
	</div>
</template>

<style lang="scss" scoped></style>
